/* eslint-disable @typescript-eslint/no-unsafe-member-access */
const headers = new Headers();
headers.append('Accept-Language', document.querySelector('html')!.lang);
headers.append('Content-Type', 'application/json');

export const PrimePhoenixService = {
    async pushData(request: any) {
        request.filesName = [];
        request.files = [];

        request.files.push(request.contractFiles);
        request.filesName.push(
            'Contract' + getFileExtension(request.contractFiles)
        );

        request.files.push(request.attestationFiles);
        request.filesName.push(
            'Attestation' + getFileExtension(request.attestationFiles)
        );

        request.numberWorker = request.numberWorker.replace(/\.|-/g, '');
        request.numberCompany = request.numberCompany.replace(/\./g, '');

        let k = 0;
        request.idFiles.forEach((i: File) => {
            request.files.push(i);
            request.filesName.push('Id' + k + getFileExtension(i));
            ++k;
        });

        request.addressCompany =
            request.addressStreetCompany +
            ' ' +
            request.addressNumberCompany +
            ', ' +
            request.addressPostalCompany +
            ' ' +
            request.addressLocalityCompany;

        request.addressWorker =
            request.addressStreetWorker +
            ' ' +
            request.addressNumberWorker +
            ', ' +
            request.addressPostalWorker +
            ' ' +
            request.addressLocalityWorker;

        request.dateSubmission.setHours(request.dateSubmission.getHours() + 2);

        request.duration = request.qHours;
        request.durationFullTime = request.sHours;

        request.phone = request.phoneCompany;

        const promises = [] as any;
        request.files.forEach((file: any) => {
            const filePromise = new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result as any);
            });
            promises.push(filePromise as any);
        });
        void Promise.all(promises).then((fileContents) => {
            request.files = fileContents;
        });

        const response = await Promise.all(promises).then((fileContents) => {
            request.files = fileContents;
            return fetch('/Umbraco/api/FondsRebondApi/PushPhoenix', {
                method: 'POST',
                body: JSON.stringify(request),
                headers,
            });
        });

        return await response.json();
    },
};

function getFileExtension(item: File): string {
    return '.' + item.name.split('.').pop();
}
